import { useEffect } from 'react';

const RIBBON_ID = 'wps-ribbon_TOP_true';

export function useRemoveWpsRibbon(): void {
  useEffect(() => {
    document.getElementById(RIBBON_ID)?.remove();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof HTMLElement && node.id === RIBBON_ID) {
            node.remove();
          }
        }
      }
    });

    observer.observe(document.body, { childList: true });

    return () => observer.disconnect();
  }, []);
}
